import { Component, Input, ViewEncapsulation } from '@angular/core';

import { GlobalNotificationEntity } from '../../../models/notifications/notification-entity.model';
import {IbpCardComponent} from "../../../ibp-components/third-party/ibp-prime-ng/ibp-card/ibp-card.component";

@Component({
  selector: 'ibp-bug-notification-card',
  standalone: true,
  templateUrl: './bug-notification-card.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [
    IbpCardComponent
  ]
})
export class BugNotificationCardComponent {
  @Input() public notification: GlobalNotificationEntity;
}
